"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resizeIndicatorId = exports.useGridResizableContext = exports.GridResizableContext = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../helpers");
const GridProvider_1 = require("./GridProvider");
const ResizeIndicator = styled_components_1.default.div `
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-right: 1px solid ${(props) => props.theme.colorHighlightDark};

    transform: translate3d(0, 0, 0);
    visibility: hidden;
`;
exports.GridResizableContext = (0, react_1.createContext)({
    onResizeToggleDown: () => { }
});
const useGridResizableContext = () => (0, react_1.useContext)(exports.GridResizableContext);
exports.useGridResizableContext = useGridResizableContext;
exports.resizeIndicatorId = 'grid-resize-indicator';
class GridResizable extends react_1.Component {
    constructor(props) {
        super(props);
        this.onMouseDown = (e, activeColumn) => {
            e.preventDefault();
            const { pageX } = e;
            const { layoutRef } = this.props;
            const { indicatorRef } = this;
            if (layoutRef.current && indicatorRef.current) {
                this.layoutRect = layoutRef.current.getBoundingClientRect();
                layoutRef.current.style.cssText = 'user-select: none';
                this.startX = pageX;
                this.activeColumn = activeColumn;
                indicatorRef.current.style.cssText = `transform: translate3d(${pageX - this.layoutRect.left}px, 0, 0); visibility: visible;`;
                document.addEventListener('mousemove', this.onMouseMove);
                /**
                 * We use capture: true as a last resort because when the grid is embedded in a modal,
                 * stopPropagation is used inside the <OverlayRoot>,
                 * which cannot currently be removed without breaking anything in the product.
                 */
                document.addEventListener('mouseup', this.onMouseUp, { capture: true, once: true });
            }
        };
        this.onMouseMove = (e) => {
            e.preventDefault();
            const { layoutRect, indicatorRef } = this;
            if (!layoutRect || !this.startX) {
                return;
            }
            const shift = e.pageX - layoutRect.left;
            const cssText = this.getStyleForIndicatorOnMove(shift, layoutRect.width);
            requestAnimationFrame(() => {
                if (indicatorRef.current) {
                    indicatorRef.current.style.cssText = cssText;
                }
            });
        };
        this.onMouseUp = (e) => {
            e.preventDefault();
            const { pageX } = e;
            const { layoutRef, onColumnResize } = this.props;
            const { updateResizedColumns } = this.context;
            const { startX, layoutRect, activeColumn, indicatorRef } = this;
            if (startX && layoutRect && activeColumn) {
                const delta = startX - pageX;
                const width = Math.max(Math.floor(activeColumn.width - delta), activeColumn.minWidth || helpers_1.MIN_CELL_WIDTH);
                const shift = e.pageX - layoutRect.left;
                if (shift > 0 && shift < layoutRect.width) {
                    updateResizedColumns({
                        [activeColumn.key]: width
                    });
                    onColumnResize === null || onColumnResize === void 0 ? void 0 : onColumnResize({
                        prevWidth: activeColumn.width,
                        width,
                        columnId: activeColumn.columnId
                    });
                }
                this.activeColumn = null;
                this.startX = null;
                this.layoutRect = null;
                document.removeEventListener('mousemove', this.onMouseMove);
                document.removeEventListener('mouseup', this.onMouseUp, { capture: true });
                requestAnimationFrame(() => {
                    if (indicatorRef.current && layoutRef.current) {
                        indicatorRef.current.removeAttribute('style');
                        layoutRef.current.removeAttribute('style');
                    }
                });
            }
        };
        this.indicatorRef = react_1.default.createRef();
        this.activeColumn = null;
        this.startX = null;
        this.layoutRect = null;
    }
    getStyleForIndicatorOnMove(shift, width) {
        if (shift > 0 && shift < width) {
            return `transform: translate3d(${shift}px, 0, 0); visibility: visible;`;
        }
        return 'visibility: hidden;';
    }
    render() {
        const { state: { resizable, disabled } } = this.context;
        const { children } = this.props;
        return (react_1.default.createElement(exports.GridResizableContext.Provider, { value: {
                onResizeToggleDown: this.onMouseDown
            } },
            children,
            resizable && !disabled && (react_1.default.createElement(ResizeIndicator, { "data-selector-id": exports.resizeIndicatorId, ref: this.indicatorRef }))));
    }
}
GridResizable.contextType = GridProvider_1.GridContext;
exports.default = GridResizable;
//# sourceMappingURL=GridResizable.js.map